import FieldsCollection from "../../fields3/collection/base/fields-collection";
import FieldDate from "../../fields3/generic/datetime/date/date";
import FieldUser from "../../fields3/generic/user/user";
import FieldMoment from "../../fields3/generic/datetime/moment/moment";
import {EntityType} from "../../gd/const/item";
import {FieldType} from "../../fields3/field-type";
import FieldText from "../../fields3/generic/text/text";
import FieldTaskTimeReported from "../../fields3/system/task/time-reported/time-reported";
import {GroupedData} from "../../data-structures/group";
import FieldCurrency from "../../fields3/generic/finance/currency/currency";
import FieldTimeOfDay from "../../fields3/generic/datetime/time-of-day/time-of-day";
import FieldTask from "../../fields3/generic/task/task";
import FieldToggle from "../../fields3/generic/boolean/toggle/toggle";
import FieldTimeReportIsBillable from "../../fields3/system/time-report/is-billable/is-billable";
import FieldTimeReportDate from "../../fields3/system/time-report/date/time-report-date";


const baseConfig = [
    {
        fieldId         : 'userId',
        // type            : FieldType.USER,
        type            : FieldType.TIME_REPORT_USER,
        // label           : 'Reported by user',
        // description     : "Choose the user for whom this report will be submitted. Manager access is required to submit on behalf of another user.",
    },
    {
        fieldId         : 'momentCreated',
        type            : FieldType.MOMENT,
        clearButton     : false
    },

    {
        fieldId         : 'reportedTimeMinutes',
        type            : FieldType.TASK_TIME_REPORTED,
        clearButton     : false,
        label           : 'Reported Time (Minutes)'
    },
    {
        fieldId         : 'date',
        type            : FieldType.TIME_REPORT_DATE,
        // type            : FieldType.DATE,
        // maxDate         : moment(),
        // clearButton     : false ,
        // label           : 'Report date',
        // description     : 'Date of Time Report'
    },
    {
        fieldId         : 'message',
        type            : FieldType.TEXT,
        label           : 'Comments'
    },
    {
        fieldId     : 'taskId',
        type        : FieldType.STRING
    },
    {
        fieldId     : 'costInternal',
        type        : FieldType.CURRENCY
    },
    {
        fieldId     : 'startMoment',
        type        : FieldType.TIME_OF_DAY,
        placeholder : "Start time",
    },
    {
        fieldId     : 'endMoment',
        type        : FieldType.TIME_OF_DAY,
        placeholder : "End time",
    },
    {
        fieldId     : 'isBillable',
        type        : FieldType.TIME_REPORT_IS_BILLABLE,
        label       : 'Is Billable'
    },

    // used as a reference
    {
        fieldId     : 'task',
        type        : FieldType.TASK,
    }
]

export default class TimeReportFields extends FieldsCollection {


    // Quick access

    get userId()                : FieldUser { return this.get('userId') as FieldUser }
    get momentCreated()         : FieldMoment { return this.get('momentCreated') as FieldMoment}
    get date()                  : FieldTimeReportDate { return this.get('date') as FieldTimeReportDate }
    get reportedTimeMinutes()   : FieldTaskTimeReported { return this.get('reportedTimeMinutes') as FieldTaskTimeReported}
    get message()               : FieldText { return this.get('message') as FieldText }
    get taskId()                : FieldText { return this.get('taskId') as FieldText }
    get costInternal()          : FieldCurrency { return this.get('costInternal') as FieldCurrency }
    get startMoment()           { return this.get('startMoment') as FieldTimeOfDay }
    get endMoment()             { return this.get('endMoment') as FieldTimeOfDay }
    get task()                  { return this.get('task') as FieldTask }
    get isBillable()            { return this.get('isBillable') as FieldTimeReportIsBillable }

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.TIME_REPORT);

    }

    get structureConditions():GroupedData {

        // this.initAllCustomFields()
        //
        // const customFields : FieldProto[] = this.customFields()

        return [
            {
                value     : 'time-report',
                label   : 'Time report',
                type   : 'system',
                items      : [
                    gd.fields.timeReport.date,
                    gd.fields.timeReport.userId,
                ]
            },
            // {
            //     value     : 'task',
            //     label   : 'Task',
            //     type   : 'system',
            //     items      : [
            //         gd.fields.task.systemStatus,
            //         gd.fields.task.priority,
            //         gd.fields.task.statusId,
            //         gd.fields.task.taskTypeId
            //
            //     ]
            // }
        ]
    }



}
